/**
 * Componente Modal de Configurações do Dashboard
 * Permite personalizar o layout e a visibilidade dos cards
 */

import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormGroup,
  Checkbox,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const SettingsModal = ({ open, onClose, numColunas, cardsVisiveis, onSave }) => {
  const [tempNumColunas, setTempNumColunas] = useState(numColunas);
  const [tempCardsVisiveis, setTempCardsVisiveis] = useState(cardsVisiveis);

  // Atualiza os valores temporários quando as props mudarem
  useEffect(() => {
    setTempNumColunas(numColunas);
    setTempCardsVisiveis(cardsVisiveis);
  }, [numColunas, cardsVisiveis, open]);

  const handleSave = () => {
    onSave(tempNumColunas, tempCardsVisiveis);
    onClose();
  };

  const handleCancel = () => {
    // Restaura os valores originais
    setTempNumColunas(numColunas);
    setTempCardsVisiveis(cardsVisiveis);
    onClose();
  };

  const handleCheckboxChange = (cardKey) => {
    setTempCardsVisiveis({
      ...tempCardsVisiveis,
      [cardKey]: !tempCardsVisiveis[cardKey],
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ borderBottom: '1px solid #dee2e6', pb: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Personalizar Visão Geral
          </Typography>
          <IconButton onClick={handleCancel} size="small" sx={{ color: '#6c757d' }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        {/* Layout de Exibição */}
        <Box sx={{ mb: 4 }}>
          <FormControl component="fieldset">
            <FormLabel component="legend" sx={{ fontWeight: 600, color: '#007bff', mb: 1.5 }}>
              Layout de Exibição
            </FormLabel>
            <RadioGroup
              value={tempNumColunas}
              onChange={(e) => setTempNumColunas(parseInt(e.target.value))}
            >
              <FormControlLabel value={1} control={<Radio />} label="1 coluna" />
              <FormControlLabel value={2} control={<Radio />} label="2 colunas" />
              <FormControlLabel value={3} control={<Radio />} label="3 colunas" />
            </RadioGroup>
          </FormControl>
        </Box>

        {/* Habilitar e Desabilitar Painéis */}
        <Box>
          <FormControl component="fieldset">
            <FormLabel component="legend" sx={{ fontWeight: 600, color: '#007bff', mb: 1.5 }}>
              Habilitar e Desabilitar Painéis
            </FormLabel>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tempCardsVisiveis.resultado}
                    onChange={() => handleCheckboxChange('resultado')}
                  />
                }
                label="Resultado do Mês"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tempCardsVisiveis.impostos}
                    onChange={() => handleCheckboxChange('impostos')}
                  />
                }
                label="Impostos a Pagar (DARF/DAS)"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tempCardsVisiveis.fluxo}
                    onChange={() => handleCheckboxChange('fluxo')}
                  />
                }
                label="Fluxo de Caixa"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tempCardsVisiveis.despesas}
                    onChange={() => handleCheckboxChange('despesas')}
                  />
                }
                label="Despesas por Categoria"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tempCardsVisiveis.dre}
                    onChange={() => handleCheckboxChange('dre')}
                  />
                }
                label="DRE (Demonstrativo do Resultado)"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tempCardsVisiveis.lancamentos}
                    onChange={() => handleCheckboxChange('lancamentos')}
                  />
                }
                label="Últimos Lançamentos"
              />
            </FormGroup>
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 2 }}>
        <Button onClick={handleCancel} sx={{ color: '#6c757d' }}>
          Cancelar
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          sx={{
            backgroundColor: '#007bff',
            '&:hover': {
              backgroundColor: '#0056b3',
            },
          }}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SettingsModal;
